<template>
    <input
        type="number"
        :value="value"
        @input="onChange"
    >
</template>

<script lang="ts" setup>
const modelValue = defineModel();
defineProps<{
  value?: string | number
}>();
const onChange = (e: Event) => {
  modelValue.value = e.target?.value;
};
</script>
